module.exports = __webpack_public_path__ + "img/Denni.01454a10.jpg";